import { Typography } from '@material-ui/core';
import { useChanges, useCollection, useIO, useLinked } from '@type-r/react';
import { Button, Flex, getParamsFromPath, Loading, PageLayout, PrimaryButton, TilesList, Toolbar } from 'lqx-react';
import * as React from 'react';
import { globalStore } from 'api';
import { CommunicationModel } from '../../../../api/communication';
import { CategoryTab } from './common';
import { CommunicationTile } from './communications-list';
import { CommunicationsHeader } from './header';
import { SearchToolbar } from './toolbar';

const defaultSort = {
    attr : 'Last Updated',
    asc : false
}

// Orders management page
export const CommunicationsPage = () => {
  const communications = globalStore.communications;
  useChanges(communications);

  const selected = useCollection.subsetOf( communications );

  const $category = useLinked<CategoryTab>( 'all' ),
        category = $category.value,
        $filter = useLinked( '' ),
        $sort = useLinked( defaultSort );

    const [ communicationId ] = getParamsFromPath();

    const isReady = useIO( async () =>{
        // Fetch orders and expired quotes in parallel.
        !communicationId && await Promise.all([
          communications.fetch()
        ]);
        selected.reset();
      },
        // Load data every time the category changes.
        [ category, communicationId ]
    );

    // Apply filter
    const filteredItems = React.useMemo(
        () =>  communications.filter( ( communications.model as any ).createFilter( category, $filter.value ) ),
        [ isReady, communications.values() ]
    )

    const allFilteredItemsLength = React.useMemo(
        () => category === 'all' ? 0 :
          communications.filter( ( communications.model as any ).createFilter( 'all', $filter.value ) ).length,
        [ isReady, $filter.value ]
    )

    const remove = async()  => {
      selected.models.forEach(comm => comm.destroy());
      selected.reset();
    }

    const markread = async(read) => {
      selected.models.forEach(comm => {comm.read = read; comm.save()});
      selected.reset();
    }

    return !communicationId ?
        <PageLayout
            header={
                <CommunicationsHeader $category={ $category } communications={ communications }/>
            }

            subheader={
              <SearchToolbar
                sortOptions={ ( communications.model as any ).sortBy }
                $filter={ $filter }
                $sort={ $sort }
              />
            }

            footer={
              <Toolbar>
                <div>{ selected.length }</div>
                { selected.length < filteredItems.length ?
                  <Button onClick={
                    () => {selected.add( filteredItems as CommunicationModel[] )}
                  }>
                    Select All
                  </Button>
                  :
                  <Button onClick={
                    () => selected.reset()
                  }>
                    Clear selection
                  </Button>
                }

                {
                  <>
                    <Flex grow />

                    <Flex row>
                      <Button
                        disabled={ false }
                        onClick={() => { markread(true) }}
                      >
                        Mark as Read
                      </Button>
                      <Button
                        disabled={ false }
                        onClick={() => { markread(false) }}
                      >
                        Mark as Unread
                      </Button>
                      <Button
                        disabled={ false }
                        onClick={() => {  remove() }}
                      >
                        Remove Selected
                      </Button>
                    </Flex>
                  </>
                }

              </Toolbar>
            }


        >
            { isReady ? (
                filteredItems.length > 0?
                    <TilesList
                        items={ filteredItems }
                        itemSize={ 60 }
                        renderer={ CommunicationTile }
                        selected={ selected }
                    />
                :
                    <Flex center stretch>
                        { allFilteredItemsLength ?
                            <Typography variant="h4">
                                { allFilteredItemsLength } matches found in other categories.
                                <PrimaryButton onClick={ () => $category.set( 'all' )}>
                                    Show
                                </PrimaryButton>
                            </Typography>
                        :
                            <Typography variant="h4">
                                No results found.
                            </Typography>
                        }
                    </Flex>
            ) :
                <Loading />
            }
        </PageLayout>
    : null
}

